import {useHistory} from "react-router";
import {entry} from "@/api/index.js";
import RegisterLayout from "@/layout/RegisterLayout";
import style from "./Resiger.scss";
import globalStyle from '@/styles/Global.scss'
import MButton from "@/components/atom/MButton";
import React from "react";
import {UserRegister} from "@/entity/User";

const RegisterConfirm = (props) => {
  const history = useHistory()
  const { userRegister } = props.location.state

  const register = async () => {
    await entry({ user: new UserRegister({...userRegister})})
    history.push('/register/done')
  }

  const goBack = () => {
    history.push('/register/register')
  }

  return (
    <>
      <RegisterLayout>
        <div className={style.container}>
          <div className={globalStyle.attribute}>
            <h3>ご登録確認</h3>
          </div>
          <div className={globalStyle.attribute}>
            <div className={globalStyle.title}>メール</div>
            <div className={globalStyle.value}>{userRegister.mail}</div>
          </div>
          <div className={globalStyle.attribute}>
            <div className={globalStyle.title}>パスワード</div>
            <div className={globalStyle.value}>********</div>
          </div>
          <div className={globalStyle.attribute}>
            <div className={globalStyle.title}>姓</div>
            <div className={globalStyle.value}>{userRegister.familyName}</div>
          </div>
          <div className={globalStyle.attribute}>
            <div className={globalStyle.title}>名</div>
            <div className={globalStyle.value}>{userRegister.firstName}</div>
          </div>
          <div className={globalStyle.attribute}>
            <div className={globalStyle.title}>姓フリガナ</div>
            <div className={globalStyle.value}>{userRegister.familyNameKana}</div>
          </div>
          <div className={globalStyle.attribute}>
            <div className={globalStyle.title}>名フリガナ</div>
            <div className={globalStyle.value}>{userRegister.firstNameKana}</div>
          </div>
          <div className={globalStyle.attribute}>
            <MButton image={'touroku.png'} value={'登録'} onClick={register}></MButton>
            <MButton image={'back.png'} value={'戻る'} onClick={goBack}></MButton>
          </div>
        </div>
      </RegisterLayout>
    </>
  )
}

export default RegisterConfirm;
